export const GET_GAME_DETAIL = "GET_GAME_DETAIL"
export const GET_GAME_ERROR = "GET_GAME_ERROR"
export const GET_GAME_REWARD = "GET_GAME_REWARD"
export const UPDATE_FLAG_IS_STOP_WHEEL = "UPDATE_FLAG_IS_STOP_WHEEL"
export const UPDATE_COUPON_URL = "UPDATE_COUPON_URL"